__turbopack_context__.v({
  "accessibility": "aBpZBq_accessibility",
  "compliance": "aBpZBq_compliance",
  "divider": "aBpZBq_divider",
  "divider2": "aBpZBq_divider2",
  "link__eVQn": "aBpZBq_link__eVQn",
  "link__ryei7": "aBpZBq_link__ryei7",
  "link__zdsG": "aBpZBq_link__zdsG",
  "privacyPolicy": "aBpZBq_privacyPolicy",
  "resources": "aBpZBq_resources",
});
